module.exports = __webpack_public_path__ + "static/media/sun-glasses-4.8444b117.jpg";